export type AcquisitionType =
  | 'batch-download'
  | 'download'
  | 'modified-download'
  | 'license'
  | 'modified-license'
  | 'savedlicense'
  | 'limited-use-products'
  | 'preview'
  | 'restricted'
  | 'ultra-pack-upsell'
  | 'cart-adp-confirmation'
  | 'modified-download-completed'
  | 'modified-download-in-progress'
  | 'modified-license-redownload'
  | 'modified-cart-confirmation'
  | 'modified-limit-use-products'
  | 'subscription-license'
  | 'subscription-download'
  | 'alacarte-license';

const acquisitionTypes: Record<string, AcquisitionType> = {
  BATCH_DOWNLOAD: 'batch-download',
  DOWNLOAD: 'download',
  MODIFIED_DOWNLOAD: 'modified-download',
  LICENSE: 'license',
  MODIFIED_LICENSE: 'modified-license',
  SAVED_LICENSE: 'savedlicense',
  LIMITED_USE_PRODUCTS: 'limited-use-products',
  PREVIEW: 'preview',
  RESTRICTED: 'restricted',
  ULTRA_PACK_UPSELL: 'ultra-pack-upsell',
  CART_ADP_CONFIRMATION: 'cart-adp-confirmation',
  MODIFIED_DOWNLOAD_COMPLETED: 'modified-download-completed',
  MODIFIED_DOWNLOAD_IN_PROGRESS: 'modified-download-in-progress',
  MODIFIED_LICENSE_REDOWNLOAD: 'modified-license-redownload',
  MODIFIED_CART_CONFIRMATION: 'modified-cart-confirmation',
  MODIFIED_LIMITED_USE_PRODUCTS: 'modified-limit-use-products',
  SUBSCRIPTION_LICENSE: 'subscription-license',
  SUBSCRIPTION_DOWNLOAD: 'subscription-download',
  ALACARTE_LICENSE: 'alacarte-license',
};

export const acquisitionTypeTitles = {
  BATCH_DOWNLOAD: 'download_with',
  MODIFIED_DOWNLOAD: 'download',
  DOWNLOAD: 'download',
  MODIFIED_LICENSE: 'purchase_license_caps',
  LICENSE: 'purchase_license_caps',
  LIMITED_USE_PRODUCTS: 'limited_use_title_caps',
  PREVIEW: 'download',
  RESTRICTED: 'restricted_asset_caps',
  ULTRA_PACK_UPSELL: 'save_with_packs_caps',
  CART_ADP_CONFIRMATION: 'purchase_license_caps',
  MODIFIED_DOWNLOAD_COMPLETED: 'download_completed',
  MODIFIED_DOWNLOAD_IN_PROGRESS: 'download',
  MODIFIED_ALC_DOWNLOAD: 'download',
  MODIFIED_LICENSE_REDOWNLOAD: 'download_image_caps',
  SUBSCRIPTION_LICENSE: 'purchase_license_caps',
  SUBSCRIPTION_DOWNLOAD: 'download_image_caps',
  ALACARTE_LICENSE: 'purchase_license_caps',
};

export default acquisitionTypes;
